<template>
  <div class="code-nvidia-app">
    <div class="header-body-bar py-15">
      <div class="header-body-text px-gen">NWORKFORCE</div>
    </div>

    <div class="side-bar px-gen py-gen">
      <menu-izq ref="menu-izq" @change_item="change_item" />
      <store-list
        ref="store_list"
        @set_stores="set_stores"
        @store_selected="store_selected"
        :active_item="active_item"
      />
    </div>
    <div class="principal py-gen">
      <solicita-bundle
        ref="solicita_bundle"
        v-show="active_item == 'request'"
      />
      <store-data
        ref="store_data"
        @store_updated="store_updated"
        @store_data_retrieved="store_data_retrieved"
        v-show="active_item == 'store'"
      />
      <bundle-active
        ref="bundle_active"
        @togside="toggle_side"
        @bundle_selected="bundle_selected"
        v-show="active_item == 'store'"
      />
      <search-results
        ref="search_results"
        v-show="active_item == 'store' && store_item == 'list'"
      />

      <reportes-store
        ref="reportes-store"
        v-show="active_item == 'store' && store_item == 'report' && false"
      />
      <reportes-pais ref="reportes_pais" v-show="active_item == 'report'" />
    </div>
    <code-request ref="code_request" @request_created="request_created" />
    <!--Modals-->
    <div class="ui dimmer modals page transition hidden">
      <!--Mientras no se active se conseva la clase "hidden" y si se activa intercambiar por "active"-->
      <div class="ui mini modal hidden transition">
        <!--Mismo caso-->
        <div class="content">
          <form class="ui form">
            <h3 class="ui dividing header fdinpro default-header-green">
              SOLICITUD DE BUNDLES
            </h3>
            <div class="has-text-centered">
              <button class="ui button notification-form">
                Si no tienes los assets del bundle descagarlos aquí
              </button>
            </div>
            <div class="field">
              <label class="pt-05 fdinpro label-form">Subir testigo web</label>
              <input type="text" name="" placeholder="" />
              <label class="pt-05 fdinpro label-form"
                >Subir testigo redes sociales</label
              >
              <input type="text" name="" placeholder="" />
              <br /><br />
              <div class="ui fluid button modal-button-green" tabindex="0">
                Solicitar Aprobación
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <store-data-modal ref="store-data-modal" />
    <user-password-modal ref="user-password-modal" />
    <bundle-active-modal ref="bundle-active-modal" />
  </div>
</template>

<script>
import BundleActive from "./BundleActive.vue";
import BundleActiveModal from "./BundleActiveModal.vue";
import CodeRequest from "./CodeRequest.vue";
import MenuIzq from "./MenuIzq.vue";
import ReportesPais from "./ReportesPais.vue";
import ReportesStore from "./ReportesStore.vue";
import SearchResults from "./SearchResults.vue";
import SolicitaBundle from "./SolicitaBundle.vue";
import StoreData from "./StoreData.vue";
import StoreDataModal from "./StoreDataModal.vue";
import StoreList from "./StoreList.vue";
import UserPasswordModal from "./UserPasswordModal.vue";

export default {
  name: "NvidiaTicketStore",
  components: {
    BundleActive,
    BundleActiveModal,
    CodeRequest,
    MenuIzq,
    ReportesPais,
    ReportesStore,
    SearchResults,
    SolicitaBundle,
    StoreData,
    StoreDataModal,
    StoreList,
    UserPasswordModal,
  },

  data() {
    return {
      stores: [], //stores in which the current user is assigned to
      active_item: "request", //
      store_item: "",
    };
  },
  methods: {
    set_stores(stores) {
      this.stores = stores;
      this.$refs.solicita_bundle.setStores(stores);
      this.$refs.reportes_pais.setStores(stores);
      // this.$refs.bundle_request.setStores(stores);
    },
    store_selected(store) {
      this.$refs.store_data.update_store(store);
      this.active_item = "store";
      this.store_item = "";
    },
    toggle_side(bundle) {
      this.$refs.code_request.toggle(bundle);
    },
    store_updated() {
      this.$refs.store_list.init();
    },
    store_data_retrieved(data) {
      let vm = this;
      vm.$refs.bundle_active.set_data(data);
    },
    bundle_selected(bundle) {
      this.$refs.search_results.setBundle(bundle);
      this.store_item = "list";
      // console.log("bundle seelcted", bundle);
    },
    change_item(item) {
      this.active_item = item;
    },
    report_bundle(bundle) {
      console.log("report_bundle", bundle);
      this.store_item = "report";
    },
    request_created() {
      console.log("now what?");
    },
  },
  mounted() {
    // let vm = this;
    // vm.$refs.code_request.setProductTypes([{ name: "cero", value: "cero" }]);
    // vm.setGPUs([{ name: "uno", value: "uno" }]);
    // vm.setBrands([{ name: "dos", value: "dos" }]);
  },
};
</script>

<style>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */
</style>

<style scoped>
.code-nvidia-app {
  background-color: #f6f2e9 !important;
  height: 100%;
  display: flex;
  flex-direction: row;
  font-family: "DINPro" !important;
  flex-wrap: wrap;
  margin-top: 0px !important;
}

body {
  background-color: #f6f2e9 !important;
  height: 100%;
  display: flex;
  flex-direction: row;
  font-family: "DINPro" !important;
  flex-wrap: wrap;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.has-text-right {
  text-align: right !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  SPACING   */
.m-0 {
  margin: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/
.px-4 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}
.py-gen {
  padding-top: 2rem;
  padding-bottom: 0;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-2 {
  padding-top: 2rem !important;
}
.pb-05 {
  padding-bottom: 0.5rem !important;
}
.py-15 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-1 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.py-4 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.pt-05 {
  padding-top: 0.5rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pt-1 {
  padding-top: 1rem !important;
}
.pt-3 {
  padding-top: 3rem !important;
}
.pl-3 {
  padding-left: 3rem !important;
}

/*  COLORS  */
.cwhite {
  color: white !important;
}
.cgray {
  color: #606060 !important;
}
.bcwhite {
  background-color: white !important;
}
.bcbeige {
  background-color: #f6f2e9 !important;
}
.bctransparent {
  background-color: transparent !important;
}

/*  HEADER    */
.header-body-bar {
  background-color: white;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
  z-index: 6;
  width: 100%;
}
.header-body-text {
  font-weight: 600;
  font-family: "DINProMedium";
  font-size: 2rem;
}
.sub-header-body-bar {
  z-index: 1;
  flex: 100%;
}
.sub-header-body-bar div {
  font-weight: 600;
  font-family: "DINProMedium";
  font-size: 1.5rem;
  color: white;
}

/*  BODY    */
.side-bar {
  flex: 20%;
  display: flex;
  flex-direction: column;
}
.principal {
  flex: 74%;
  background-color: white;
  z-index: 4;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
.notification-form {
  font-size: 0.8rem !important;
  width: 100%;
}
.label-form {
  font-size: 0.8rem !important;
}

/*  SOLICITAR CODIGO    */
.request-code- {
  color: white !important;
  border-bottom: 2pt solid white !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}

/*  USUARIO TIENDA  */
.ui.container {
  width: auto !important;
}
.pheader {
  font-weight: 300;
  font-size: 1.5rem !important;
  padding: 0.5rem 0 !important;
}
.search-by-date {
  width: 100%;
}
.table-codes- {
  font-size: 90% !important;
  overflow-y: scroll;
  height: 62vh;
}
.table-codes- table thead tr th {
  padding-bottom: 0.25rem !important;
}
.table-codes- table tbody tr td {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}

/*  WEB SERVICES    */
.web-service {
  background-color: #fbfaf6 !important;
  height: 100%;
  width: 100% !important;
}
.web-service-icon {
  color: red;
  padding-right: 2rem !important;
}
.web-service-icon.active {
  color: greenyellow;
}

/*INFO STORE*/
.info-store {
  align-items: center !important;
}
.info-store .six h5 {
  font-size: 90% !important;
}
.info-store .four button {
  flex: 20%;
  text-align: center;
  font-size: 90% !important;
}

/**/
.info-bundle {
  background-color: #ebebec !important;
}
.info-bundle .ten table tbody tr td {
  text-align: center;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .ten table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .ten table tbody tr .six.wide button {
  border-radius: 2rem;
}
.info-bundle .six table tbody tr td {
  text-align: left;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .six table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .six table tbody tr .six.wide button {
  border-radius: 2rem;
}
.chart.pie.icon.active {
  color: #365a0c;
}
.ibundle-button-green {
  background-color: #666666 !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.ibundle-button-green.active {
  background-color: #365a0c !important;
}
.ibundle-button-green:hover {
  background-color: #365a0c !important;
}

.ib-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
  font-size: 90% !important;
  padding: 0.5rem 1rem 0.5rem !important;
}
.ib-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.ib-button.active {
  color: white !important;
  background-color: #365a0c !important;
}

/*TABLA CODIGOS NVIDIA */
.nvidia-table-codes- {
  font-size: 90% !important;
  overflow-y: scroll;
  height: 35vh;
}
.nvidia-table-codes- table thead tr th {
  padding-bottom: 0.25rem !important;
}
.nvidia-table-codes- table tbody tr td {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}

.act-bundles {
  background-color: #ebebec !important;
}
.act-bundles .grid div button {
  border-radius: 2rem !important;
}

.testigos div p {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  margin-bottom: 0;
}
.testigos div .grid {
  align-items: center !important;
  background-color: #ebebec !important;
}

.rpassword {
  color: black !important;
  font-weight: 700 !important;
}
.rpassword:hover {
  color: #365a0c !important;
}
</style>
